import React, { useEffect, useRef, useState } from "react";
import Get from "../services/Get";
import {
  Button,
  Col,
  List,
  message,
  Row,
  Tabs,
  Typography,
  Input,
  Modal,
  Upload,
  Select,
  Radio,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  CalendarFilled,
  DownloadOutlined,
  PlusCircleOutlined,
  ScanOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import Post from "../services/Post";
import IdCard from "../components/modal/IdCard";
import ViewAttendance from "../components/modal/ViewAttendance";
import card1 from "../assets/images/card-1.png";
import card2 from "../assets/images/card-2.png";
import card3 from "../assets/images/card-3.png";
import card4 from "../assets/images/card-4.png";
import A4List from "../components/modal/A4List";
import jsPDF from "jspdf";
import CardDefault from "../components/idCards/CardDefault";
import html2canvas from "html2canvas";
import ReactDOM from "react-dom";

const Members = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const { Search } = Input;

  const [members, setMembers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profile, setProfile] = useState();
  const [studentProfile, setStudentProfile] = useState();
  const [qrData, setQrData] = useState();
  const [qrStudentData, setQrStudentData] = useState();
  const [logo, setLogo] = useState();
  const [schoolLogo, setSchoolLogo] = useState();
  const [selectedMember, setSelectedMember] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedStudent, setSelectedStudent] = useState();
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [isAttOpen, setIsAttOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [currentType, setCurrentType] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 5,
    total: 0,
  });
  const [driversPagination, setDriversPagination] = useState({
    page: 1,
    pageSize: 5,
    total: 0,
  });
  const [studentsPagination, setStudentsPagination] = useState({
    page: 1,
    pageSize: 5,
    total: 0,
  });
  const [classFilter, setClassFilter] = useState("All");
  const [sectionFilter, setSectionFilter] = useState("All");
  const [cardTypeModal, setCardTypeModal] = useState(false);
  const [isA4Open, setIsA4Open] = useState(false);

  const classOptions = [
    "All",
    "Pre-Nursery",
    "Nursery",
    "KG",
    "LKG",
    "UKG",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ].map((className) => ({
    label: className,
    value: className,
  }));

  const sectionOptions = [
    "All",
    ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  ].map((letter) => ({
    label: letter,
    value: letter,
  }));

  const handleCardSelection = async () => {
    if (!selectedCard) {
      return message.error("Please select a card design.");
    }
    console.log("Selected Card Design:", selectedCard);
    const response = await Post.UpdateCardType(selectedCard);

    console.log(response);
    if (response.error) {
      message.error(response.error);
    } else {
      message.success(response.message);
      setCardTypeModal(false);
    }
  };

  const cardDesigns = [
    { id: 1, image: card1 },
    { id: 2, image: card2 },
    { id: 3, image: card3 },
    { id: 4, image: card4 },
  ];

  const handleOpenAttendance = (type) => {
    setCurrentType(type); // Set the correct type before opening the modal
    setIsAttOpen(true);
  };

  const getMembers = (
    page = 1,
    pageSize = 5,
    search = "",
    classFilter = "",
    sectionFilter = "",
    type = ""
  ) => {
    setLoading(true);

    Get.getMembers({
      page,
      per_page: pageSize,
      search,
      classFilter,
      sectionFilter,
      type,
    })
      .then((res) => {
        setMembers(res.members);
        setDrivers(res.drivers);
        setStudents(res.students);

        setPagination({
          page: res.members_pagination.current_page,
          pageSize,
          total: res.members_pagination.total,
        });

        setDriversPagination({
          page: res.drivers_pagination.current_page,
          pageSize,
          total: res.drivers_pagination.total,
        });

        setStudentsPagination({
          page: res.students_pagination.current_page,
          pageSize,
          total: res.students_pagination.total,
        });
      })
      .catch(() => {
        message.error("Failed to fetch members. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  const showCard = (item) => {
    setLoading(true);
    Get.getSingleMember(item.id)
      .then((res) => {
        console.log(res);

        setProfile(res.profile);
        setQrData(res.qr_code);
        setLogo(res.logo);
        setSelectedMember(res.data);
        setSelectedCompany(res.company);
        setIsQrModalOpen(true);
      })
      .catch((error) => {
        console.error(error);

        message.error(error);
      })
      .finally(() => setLoading(false));
  };

  const showStudentCard = (item) => {
    setLoading(true);
    Get.getSingleStudent(item.id)
      .then((res) => {
        setStudentProfile(res.profile);
        setQrStudentData(res.qr_code);
        setSchoolLogo(res.logo);
        setSelectedStudent(res.data);
        setIsStudentModalOpen(true);
      })
      .catch((error) => {
        console.error(error);
        message.error(error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getMembers();
  }, []);

  const handleDownload = (type) => {
    const fileUrl = `https://manage.rebatedekho.com/storage/${type}.xlsx`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", `${type}.xlsx`); // Set filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = async (type) => {
    setDownloading(true);
    setLoading(true);

    const res = await Get.getAllMembers({ type });
    const pdfData = res.members;

    const pdf = new jsPDF("p", "mm", "a4"); // A4 in portrait mode

    const marginX = 15; // Left margin
    const marginY = 10; // Top margin
    const gapX = 3; // Horizontal gap (for vertical cards)
    const gapY = 3; // Vertical gap

    let x = marginX;
    let y = marginY;
    let cardsPerPage = 0;

    const cardContainer = document.createElement("div");
    cardContainer.style.position = "absolute";
    cardContainer.style.left = "-9999px"; // Hide from viewport
    document.body.appendChild(cardContainer);

    const generateCardImage = async (card) => {
      cardContainer.innerHTML = ""; // Clear previous content
      const cardElement = document.createElement("div");
      cardContainer.appendChild(cardElement);

      ReactDOM.render(
        <CardDefault
          logo={card.logo}
          profile={card.profile}
          company={card.company}
          candidateName={card.name}
          displayNumber={card.qr_no}
          mobile={card.mobile}
          qrData={card.qr_code}
        />,
        cardElement
      );

      await new Promise((resolve) => setTimeout(resolve, 500)); // Wait for rendering

      const canvas = await html2canvas(cardElement, { scale: 2 });
      return {
        imgData: canvas.toDataURL("image/png"),
        width: canvas.width / 12, // Auto width
        height: canvas.height / 12, // Auto height
      };
    };

    const generatePDF = async () => {
      for (let index = 0; index < pdfData.length; index++) {
        const card = pdfData[index];
        const { imgData, width, height } = await generateCardImage(card);

        if (cardsPerPage % 3 === 0 && cardsPerPage !== 0) {
          y += height + gapY;
          x = marginX;
        }

        if (cardsPerPage === 9) {
          pdf.addPage();
          x = marginX;
          y = marginY;
          cardsPerPage = 0;
        }

        pdf.addImage(imgData, "PNG", x, y, width, height);
        x += width + gapX; // Move to the next column

        cardsPerPage++;
      }

      pdf.save("ID_Cards.pdf");
      setDownloading(false);
      setLoading(false);
      document.body.removeChild(cardContainer);
    };

    generatePDF();
  };

  // Function to handle file upload and convert Excel to JSON
  const handleFileUpload = async (file, type) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        // Format data with dynamic fields
        const formattedData = jsonData.map((row) => ({
          name: row.name || row.Name || "",
          mobile: row.mobile || row.Mobile || "",
          ...(type === "student"
            ? {
                class: row.class || row.Class || "",
                section: row.section || row.Section || "",
                admission_no: row.admission_no || row.Admission_no || "",
                parent_name: row.parent_name || row.Parent_name || "",
              }
            : {}),
        }));

        console.log("Uploaded Excel Data:", formattedData);

        const formData = {
          data: formattedData,
          member_type: type,
        };

        let response;
        if (type === "student") {
          response = await Post.AddStudents(formData);
        } else {
          response = await Post.AddMembers(formData);
        }

        console.log(response);
        if (response.error) {
          message.error(response.error);
        } else {
          message.success("Excel file uploaded successfully!");
          setIsModalOpen(false); // Close modal after processing
        }
      } catch (error) {
        console.error("Error processing file:", error);
        message.error("Failed to process the file. Please check the format.");
      }
    };

    reader.readAsArrayBuffer(file);
    return false; // Prevent default upload behavior
  };

  const ListMembers = ({ members, type }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [isLinkIdModalOpen, setIsLinkIdModalOpen] = useState(false);
    const inputRef = useRef(null);

    const idSubmitted = async (e) => {
      e.preventDefault(); // prevent page reload
      const rfid = e.target.rfid.value; // get input value
      const dataToSend = {
        rfid: rfid,
        type,
        memberId: selectedMember.id,
      };

      console.log("dataToSend ==== ", dataToSend);

      if (rfid.trim() === "") {
        message.error("RFID cannot be empty");
        return;
      }

      const response = await Post.LinkRFID(dataToSend);

      if (response.error) {
        message.error(response.error);
      }

      message.success(`RFID "${rfid}" linked successfully`);
      setIsLinkIdModalOpen(false); // close modal if needed
      setSelectedMember(null);
      e.target.reset(); // reset form
    };

    const handleLinkRfidClick = (item) => {
      setSelectedMember(item); // Update selected member
      setIsLinkIdModalOpen(true); // Then open modal
    };

    const handleSearch = () => {
      getMembers(
        1,
        pagination.pageSize,
        searchQuery,
        classFilter,
        sectionFilter,
        type
      );
    };

    const handleClassChange = (value) => {
      setClassFilter(value);
      getMembers(
        1,
        pagination.pageSize,
        searchQuery,
        value,
        sectionFilter,
        type
      );
    };

    const handleSectionChange = (value) => {
      setSectionFilter(value);
      getMembers(1, pagination.pageSize, searchQuery, classFilter, value, type);
    };

    useEffect(() => {
      if (isLinkIdModalOpen && inputRef.current) {
        // Give it a tick to make sure modal content is mounted
        setTimeout(() => {
          inputRef.current.focus();
        }, 100);
      }
    }, [isLinkIdModalOpen]);

    return (
      <>
        <Row justify="end" className="mb-4">
          <Button
            type="primary"
            className="form-btn"
            onClick={() => navigate(`/user/add-user/${type}`)}
          >
            <PlusCircleOutlined /> Add{" "}
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </Button>
          <Button
            type="primary"
            icon={<UploadOutlined />}
            className="form-btn ml-5"
            onClick={() => setIsModalOpen(true)}
          >
            Add Excel
          </Button>
          {type == "student" ? (
            <Button
              type="primary"
              className="form-btn ml-5"
              onClick={() => setCardTypeModal(true)}
            >
              Select Card Type
            </Button>
          ) : (
            <Button
              type="primary"
              className="form-btn ml-5"
              disabled={downloading}
              onClick={() => handleDownloadPDF(type)}
            >
              Download PDF
            </Button>
          )}
          <Button
            type="primary"
            icon={<CalendarFilled />}
            className="form-btn ml-5"
            onClick={() => handleOpenAttendance(type)}
          >
            View Attendance
          </Button>
          <Button
            type="primary"
            icon={<ScanOutlined />}
            className="form-btn ml-5"
            onClick={() => navigate('/user/attendance-scan')}
          >
            Attendance Scan
          </Button>
        </Row>

        {/* Excel Upload Modal */}
        <Modal
          title="Upload Excel File"
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
        >
          <Button
            type="primary"
            className="form-btn mb-4"
            icon={<DownloadOutlined />}
            onClick={() => handleDownload(type)}
          >
            Download Template
          </Button>
          <br />
          <Upload
            beforeUpload={(file) => handleFileUpload(file, type)}
            fileList={fileList}
            onRemove={() => setFileList([])}
            accept=".xls,.xlsx"
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Modal>

        <Modal className="link__rfid"
          title="Link RFID"
          open={isLinkIdModalOpen}
          footer={null}
          onCancel={() => setIsLinkIdModalOpen(false)}
        >
          <form onSubmit={idSubmitted}>
            <input ref={inputRef} type="text" name="rfid" autoFocus />
            <p className="link__text">Please Scan Your Card To Link RFID!</p>
          </form>

        </Modal>

        {/* Search & Filters */}
        <Row gutter={[10, 10]} className="mb-4">
          <Col span={24}>
            <Search
              placeholder={`Search ${type}`}
              enterButton={<button className="search-button">Search</button>}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onSearch={handleSearch}
              allowClear
            />
          </Col>

          {type === "student" && (
            <>
              <Col span={10}>
                <Typography.Title level={5}>Class</Typography.Title>
                <Select
                  size="middle"
                  onChange={handleClassChange}
                  style={{
                    width: "100%",
                  }}
                  value={classFilter}
                  options={classOptions}
                />
              </Col>
              <Col span={10}>
                <Typography.Title level={5}>Section</Typography.Title>
                <Select
                  size="middle"
                  onChange={handleSectionChange}
                  style={{
                    width: "100%",
                  }}
                  value={sectionFilter}
                  options={sectionOptions}
                />
              </Col>
              <Col span={4}>
                <Typography.Title level={5}>ID Card PDF</Typography.Title>
                <Button
                  type="primary"
                  className="form-btn ml-5"
                  onClick={() => setIsA4Open(true)}
                >
                  Download
                </Button>
              </Col>
            </>
          )}
        </Row>

        <List
          header={<Typography.Title level={4}>All {type}</Typography.Title>}
          bordered
          loading={loading}
          dataSource={members}
          pagination={{
            current:
              type === "student"
                ? studentsPagination.page
                : type === "driver"
                ? driversPagination.page
                : pagination.page,
            pageSize:
              type === "student"
                ? studentsPagination.pageSize
                : type === "driver"
                ? driversPagination.pageSize
                : pagination.pageSize,
            total:
              type === "student"
                ? studentsPagination.total
                : type === "driver"
                ? driversPagination.total
                : pagination.total,
            onChange: (page, pageSize) => {
              getMembers(
                page,
                pageSize,
                searchQuery,
                classFilter,
                sectionFilter,
                type
              );
            },
          }}
          renderItem={(item) => (
            <List.Item
              actions={
                type === "student"
                  ? [
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => handleLinkRfidClick(item)}
                      >
                        Link RFID
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() =>
                          navigate(`/user/edit-member/student/${item.id}`)
                        }
                      >
                        Edit Student
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => showStudentCard(item)}
                      >
                        View ID Card
                      </Button>,
                    ]
                  : [
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() =>
                          navigate("/user/members/vehicles", {
                            state: { member: item },
                          })
                        }
                      >
                        View Vehicles
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => handleLinkRfidClick(item)}
                      >
                        Link RFID
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() =>
                          navigate(`/user/edit-member/member/${item.id}`)
                        }
                      >
                        Edit Member
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => showCard(item)}
                      >
                        Get ID Card
                      </Button>,
                    ]
              }
            >
              <List.Item.Meta
                title={item.name}
                description={
                  type === "student" ? (
                    <>
                      <div>
                        Class: {item.class}-{item.section}
                      </div>
                      <div>Admission no: {item.admission_no}</div>
                    </>
                  ) : (
                    <>
                      <div>Number of vehicles: {item.vehicles.length}</div>
                      <div>Mobile: {item.mobile}</div>
                    </>
                  )
                }
              />
            </List.Item>
          )}
        />
      </>
    );
  };

  const items = [];

  if (user.businessType.allow_employees === 1) {
    items.push({
      key: "members",
      label: "Members",
      children: <ListMembers members={members} type="member" />,
    });
  }

  if (user.businessType.allow_drivers === 1) {
    items.push({
      key: "drivers",
      label: "Drivers",
      children: <ListMembers members={drivers} type="driver" />,
    });
  }

  if (user.businessType.allow_parents === 1) {
    items.push({
      key: "students",
      label: "Students",
      children: <ListMembers members={students} type="student" />,
    });
  }

  return (
    <div className="layout-content">
      <Row justify="center">
        <Col xs={24} md={12}>
          {items.length > 0 ? (
            <>
              <Tabs items={items} />
            </>
          ) : (
            <Typography.Text>No access to any category</Typography.Text>
          )}
        </Col>

        <Modal
          title="Select Card Design"
          open={cardTypeModal}
          onCancel={() => setCardTypeModal(false)}
          footer={[
            <Button key="cancel" onClick={() => setCardTypeModal(false)}>
              Cancel
            </Button>,
            <Button
              key="select"
              type="primary"
              className="form-btn"
              onClick={handleCardSelection}
              disabled={!selectedCard}
            >
              Select
            </Button>,
          ]}
        >
          <Radio.Group
            onChange={(e) => setSelectedCard(e.target.value)}
            value={selectedCard}
          >
            <Row>
              {cardDesigns.map((card) => (
                <Col xs={24} key={card.id}>
                  <Radio value={card.id}>
                    <img
                      src={card.image}
                      alt={`Card ${card.id}`}
                      style={{
                        width: "100%",
                        maxHeight: "400px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </Radio>
                </Col>
              ))}
            </Row>
          </Radio.Group>
        </Modal>

        <IdCard
          isModalOpen={isQrModalOpen}
          setIsModalOpen={setIsQrModalOpen}
          title="Member ID Card"
          profile={profile}
          company={selectedCompany}
          candidateName={selectedMember?.name}
          displayNumber={selectedMember?.qr_no}
          mobile={selectedMember?.mobile}
          qrData={qrData}
          logo={logo}
        />

        <IdCard
          isModalOpen={isStudentModalOpen}
          setIsModalOpen={setIsStudentModalOpen}
          title="Student ID Card"
          profile={studentProfile}
          candidateName={selectedStudent?.name}
          studentClass={selectedStudent?.class}
          studentSection={selectedStudent?.section}
          studentAdmission={selectedStudent?.admission_no}
          displayNumber={selectedStudent?.qr_no}
          fathersName={selectedStudent?.parent.name}
          schoolName={selectedStudent?.school.name}
          mobile={selectedStudent?.parent.mobile}
          schoolMobile={selectedStudent?.school.mobile}
          schoolAddress={selectedStudent?.school.address}
          cardType={selectedStudent?.school.card_type}
          qrData={qrStudentData}
          logo={schoolLogo}
        />

        <A4List
          isModalVisible={isA4Open}
          setIsModalVisible={setIsA4Open}
          studentsData={students}
          classFilter={classFilter}
          sectionFilter={sectionFilter}
        />

        <ViewAttendance
          isAttOpen={isAttOpen}
          setIsAttOpen={setIsAttOpen}
          type={currentType}
        />
      </Row>
    </div>
  );
};

export default Members;
